import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { AssignCaseworkerTaskDialogComponent } from './assign-caseworker-for-task-component';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';
import { ReassignTasksRequest } from '../../../../api-service/clients';
import { useAuthenticatedUser } from '../../../../authentication';

export interface IAssignCaseworkerTaskDialogProps {
  taskIds?: string[];
  onCompleted?: () => void;
}

export function AssignCaseworkerTaskDialog({ taskIds, onCompleted }: IAssignCaseworkerTaskDialogProps) {
  const [userId, setUserId] = useState<string | undefined>();
  const [teamId, setTeamId] = useState<string | undefined>();
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const [isConfirmed, setIsConfirmed] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const currentUserId = useAuthenticatedUser()?.profile.id;

  const setTeamForUserId = async (id: string | undefined) => {
    if (id) {
      const organizationClient = moduleClientFactory.createOrganizationClient(true);
      const response = await organizationClient.getUserById({ userId: id });
      setTeamId(response.user?.teamId);
    } else {
      setTeamId(undefined);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setIsConfirmed(false);

      setUserId(currentUserId);

      if (currentUserId) {
        setTeamForUserId(currentUserId);
      }
    }
  }, [currentUserId, isOpen]);

  const handleConfirm = async () => {
    const request: ReassignTasksRequest = {
      responsibleTeamId: teamId ?? '',
      taskIds,
      responsibleCaseWorkerId: userId,
    };

    async function reassignTasksAsync() {
      await moduleClientFactory.createJobcenterTaskClient().reassignTasks(request);
    }

    setIsConfirmed(true);

    await reassignTasksAsync();
    enqueueSnackbar('Alle opgaver blev tildelt', { variant: 'success' });
    onCompleted?.();

    setIsOpen(false);
  };

  const handleTeamChange = (value: string | undefined) => {
    setTeamId(value);
    setUserId(undefined);
  };

  const handleUserChange = async (selectedUserId: string | undefined) => {
    setUserId(selectedUserId);

    await setTeamForUserId(selectedUserId ?? currentUserId);
  };

  if (!isOpen) {
    return null;
  }
  function handleClose() {
    setIsOpen(false);
  }
  return (
    <AssignCaseworkerTaskDialogComponent
      onConfirm={handleConfirm}
      onTeamChange={handleTeamChange}
      onUserChange={handleUserChange}
      teamId={teamId}
      userId={userId}
      isOpen={isOpen}
      onClose={handleClose}
      isLoading={isConfirmed}
    />
  );
}
